import { Component, ViewChild, OnInit } from '@angular/core';
import { PurchaseorderService } from '../../../services/purchaseorder.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReportLookupComponent } from '../../Reports/report-lookup/report-lookup.component';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { Table } from 'primeng/table';
import { gridPageRequest } from '../../../model/common/common.model';
import { ReportCenterService } from '../../../services/report-center.service';

@Component({
  selector: 'app-receipt-report-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './receipt-lookup.component.html',
  styleUrls: ['./receipt-lookup.component.scss']
})
export class receiptLookupComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;
  selectedPOrder: any[] = []; // Initialize as an empty array
  loader: boolean = false;
  POReceiptList: any;
  pageRequest: gridPageRequest = { pageIndex: 0, pageSize: 1, id: 0 };
  poReceiptHeaderId:any;

  constructor(
    private config: DynamicDialogConfig,
    private porderservice: PurchaseorderService,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,private reportService : ReportCenterService
  ) {}

  ngOnInit(): void {
    const POReceiptHeaderId = this.config.data?.poReceiptHeaderId;
    this.poReceiptHeaderId = POReceiptHeaderId;
    this.getReceipt(POReceiptHeaderId);
  }

  getReceipt(POReceiptHeaderId: any): void {
    this.loader = true;
    this.porderservice.getPOReceiptHeader(POReceiptHeaderId).subscribe({
      next: (data: any) => {
        this.POReceiptList = data.POReceiptHeaderId;
        this.selectedPOrder = data.POReceiptHeaderId || [];
        this.loader = false;
      },
      error: (error) => {
        console.error(error);
        this.loader = false;
      }
    });
  }

showReport(): void {
  const formCode = 'Receipt';

  if (this.poReceiptHeaderId) {
    this.reportService.getReportName(formCode).subscribe({
      next: (report: any) => {
        const receiptNumber = this.poReceiptHeaderId.poReceiptNumber;

        const sanitizedNumber = receiptNumber.replace(/[^a-zA-Z0-9]/g, "_");

        document.title = sanitizedNumber;

        this.ref = this.dialogService.open(ReportLookupComponent, {
          header: 'Receipt Order', 
          width: '100%',
          data: {
            OrderNo: receiptNumber,
            ReportName: sanitizedNumber, 
            ReportPath: report.path
          }
        });
        this.ref.onClose.subscribe(() => {
          document.title = 'Receipt List';
        });
      },
      error: (err: any) => {
        console.error(`Report not found for form code: ${formCode}`, err);
      }
    });
  } 
}


showReport1(): void {
  const formCode = 'GRN'; 

  if (this.poReceiptHeaderId) {
    this.reportService.getReportName(formCode).subscribe({
      next: (report: any) => {
        const receiptNumber = this.poReceiptHeaderId.poReceiptNumber;
        const sanitizedNumber = receiptNumber.replace(/[^a-zA-Z0-9]/g, "_");
        document.title = sanitizedNumber;

        this.ref = this.dialogService.open(ReportLookupComponent, {
          header: report.formName,
          width: '100%',
          data: {
            OrderNo: receiptNumber,
            ReportName: sanitizedNumber, 
            ReportPath: report.path
          }
        });
        this.ref.onClose.subscribe(() => {
          document.title = 'GRN List';
        });
      },
      error: (err: any) => {
        console.error(`Report not found for form code: ${formCode}`, err);
      }
    });
  } else {
    console.warn('No OrderNo provided for GRN');
  }
}


}
